import VueTypes from 'vue-types'
import props from './validity.props'
import validators from './validators'

export default {
  name: 'gkui-form-controller',
  components: {
  },
  props: Object.assign({
    type: VueTypes.string.def('input'),
    readonly: VueTypes.bool.def(false),
    disabled: VueTypes.bool.def(false),
    /**
     * 需要 render 的 dom
     * form.controller 由 高阶函数 validity 调用渲染
     */
    child: VueTypes.object.isRequired
  }, props),
  data () {
    return {
      valid: true,
      touched: false,
      process: false,
      currentValue: this.value,
      message: '',
      delayInputTime: [],
      isChInput: false
    }
  },
  inject: {
    /**
     * 依赖注入，把验证项注册到 form
     * form 会使用 this.group this.field this.validate
     */
    _gkuiFormRegister: {
      default: null
    },
    /**
     * 依赖注入，把验证项从 form 中销毁
     * form 会使用 this.group this.field
     */
    _gkuiFormUnregister: {
      default: null
    },
    /**
     * 依赖注入，上报验证结果到 form
     * @param {Object}  model          验证项数据
     * @param {String}  model.group    验证项的分组名称
     * @param {String}  model.field    验证项的标识
     * @param {String}  model.value    验证项的值
     * @param {Boolean} model.touched  是否已验证
     * @param {Boolean} model.process  是否正在验证中
     * @param {Boolean} model.valid    验证是否已通过
     * @param {Boolean} model.invalid  验证是否失败
     * @param {Boolean} model.message  验证失败时的消息
     */
    _gkuiFormAcceptModel: {
      default: null
    }
  },
  computed: {
    usedValidity () {
      return this.validity && !this.disabled && !this.readonly && this.rule && this.rule.length
    },
    usedFocusValidate () {
      return this.trigger.indexOf('focus') !== -1
    },
    usedInputValidate () {
      return this.trigger.indexOf('input') !== -1
    },
    usedBlurValidate () {
      return this.trigger.indexOf('blur') !== -1
    },
    /**
     * 数组形式的验证条件
     */
    arrRule () {
      let arr = Array.isArray(this.rule) ? this.rule : this.rule.split(',')

      arr = arr.filter(rule => !!rule)

      return arr.map(item => {
        let rule = {}

        if (typeof item === 'string') {
          rule.name = item
        }

        if (typeof item === 'object') {
          const key = Object.keys(item)[0]
          rule.name = key
          rule.message = item[key]
        }

        return rule
      })
    },
    /**
     * map 形式的验证条件
     */
    mapRule () {
      return this.arrRule.reduce((map, rule) => {
        map[rule.name] = rule
        return map
      }, {})
    },
    /**
     * 验证项数据
     * @param {Object}  model          验证项数据
     * @param {String}  model.group    验证项的分组名称
     * @param {String}  model.field    验证项的标识
     * @param {String}  model.value    验证项的值
     * @param {Boolean} model.touched  是否已验证
     * @param {Boolean} model.process  是否正在验证中
     * @param {Boolean} model.valid    验证是否已通过
     * @param {Boolean} model.invalid  验证是否失败
     * @param {Boolean} model.message  验证失败时的消息
     */
    result () {
      return {
        group: this.group,
        field: this.field,
        value: this.currentValue,
        touched: this.touched,
        process: this.process,
        valid: this.valid,
        invalid: !this.valid,
        message: this.message
      }
    }
  },
  watch: {
    /**
     * 更新内部数据
     * 因为已绑定 input 事件，所以当非输入变化是才触发更新
     * @param {String} val 外部传入的值，作为初始化或者指定更新时使用
     */
    value (val) {
      if (this.currentValue !== val) {
        this.currentValue = val
        this.$el.value = this.currentValue
      }

      if (this.type === 'hidden') {
        this.handleChange(null, val)
      }
    },
    /**
     * 变动时，执行注册/销毁到 form 的操作
     */
    usedValidity (val) {
      // 移除动态切换是否使用验证的逻辑
      // val ? this.register() : this.unregister()
      this.reset()
    },
    disabled (disabled) {
      this.$el.disabled = disabled
    },
    readonly (readonly) {
      this.$el.readOnly = readonly
    }
    // ,
    // touched (val) {
    //   console.log(`touched: ${val}`)
    // },
    // process (val) {
    //   console.log(`process: ${val}`)
    // }
  },
  created () {
    this.init()
  },
  mounted () {
    this.$el.value = this.currentValue
    this.$el.disabled = this.disabled
    this.$el.readOnly = this.readonly

    if (this.type === 'text' || this.type === 'textarea') {
      this.$el.addEventListener('compositionstart', this.handleInputCNStart)
      this.$el.addEventListener('compositionend', this.handleInputCNEnd)
      this.$el.addEventListener('focus', this.handleFocus)
      this.$el.addEventListener('input', this.handleInput)
      this.$el.addEventListener('blur', this.handleBlur)
    } else {
      this.$el.addEventListener('input', this.handleInput)
    }
  },
  beforeDestroy () {
    this.unregister()

    if (this.type === 'text' || this.type === 'textarea') {
      this.$el.removeEventListener('compositionstart', this.handleInputCNStart)
      this.$el.removeEventListener('compositionend', this.handleInputCNEnd)
      this.$el.removeEventListener('focus', this.handleFocus)
      this.$el.removeEventListener('input', this.handleInput)
      this.$el.removeEventListener('blur', this.handleBlur)
    } else {
      this.$el.removeEventListener('input', this.handleInput)
    }
  },
  render (h) {
    return this.child
  },
  methods: {
    /**
     * 初始化，执行注册到 form
     */
    init () {
      // 所有子项均使用验证方法上报验证项的值
      // this.usedValidity && this.register()
      this.register()
    },
    /**
     * 使用注入的方法注册到 form
     */
    register () {
      this._gkuiFormRegister && this._gkuiFormRegister(this)
    },
    /**
     * 使用注入的方法从 form 中销毁
     */
    unregister () {
      this._gkuiFormUnregister && this._gkuiFormUnregister(this)
    },
    /**
     * change 的功能
     * 执行验证方法
     * $emit input
     */
    handleChange (event, value) {
      value = event ? event.target.value : value

      this.valid = false

      this.$emit('input', value, event)

      // 所有子项均使用验证方法上报验证项的值
      // this.usedValidity && this.usedInputValidate && this.validate(value)
      this.usedInputValidate && this.validate(value)
    },
    /**
     * 获得焦点时的功能
     * 执行验证方法
     * $emit focus
     */
    handleFocus (event) {
      this.$emit('focus', event, event.target.value)

      // 所有子项均使用验证方法上报验证项的值
      // this.usedValidity && this.usedFocusValidate && this.validate(event.target.value)
      this.usedFocusValidate && this.validate(event.target.value)
    },
    handleInputCNStart () {
      this.isChInput = true
    },
    handleInputCNEnd (event) {
      this.isChInput = false
      this.handleInput(event)
    },
    /**
     * 输入时的功能
     * 执行验证方法
     * $emit input
     */
    handleInput (event) {
      if (this.isChInput) {
        return ''
      }

      const value = event.target.value

      this.valid = false
      this.currentValue = value

      this.$emit('input', value, event)

      if (this.delay) {
        const time = Date.now()

        this.delayInputTime.push(time)

        setTimeout(() => {
          if (time === this.delayInputTime[this.delayInputTime.length - 1]) {
            this.usedValidity && this.usedInputValidate && this.validate(value)

            this.$emit('delay', value)
          }
        }, this.delay)
      } else {
        this.validate(value)
      }
    },
    /**
     * 失焦时的功能
     * 执行验证方法
     * $emit blur
     */
    handleBlur (event) {
      this.$emit('blur', event, event.target.value)

      // 所有子项均使用验证方法上报验证项的值
      // this.usedValidity && this.usedBlurValidate && this.validate(event.target.value)
      this.usedBlurValidate && this.validate(event.target.value)
    },
    clear () {
      this.currentValue = ''
      this.$el.value = ''
      this.$emit('input', '')
      this.reset()
    },
    reset () {
      this.touched = false
      this.process = false
      this.valid = true
      this.message = ''

      this.pushResult()
    },
    async validate (value) {
      if (this.valid && this.touched) {
        return {valid: true}
      }

      value = value || this.currentValue

      let valid = true

      this.message = ''
      this.process = true

      if (!(value === '' && !this.arrRule.find(rule => rule.name === 'required'))) {
        for (let i = 0; i < this.arrRule.length; i++) {
          const rule = this.arrRule[i]
          const method = validators[rule.name] || this.customRule[rule.name]
          let validResult

          if (!method) {
            console.warn(`不存在 "${rule.name}" 此验证规则!!!`)
            continue
          }

          validResult = await method(value) || {}

          if (!validResult.valid) {
            valid = false
            this.message = rule.message || validResult.message
            break
          }
        }
      }

      this.touched = true
      this.process = false
      this.valid = valid

      this.pushResult()

      return {
        $el: this.$el,
        field: this.field,
        valid: valid,
        message: this.message
      }
    },
    /**
     * 验证项数据
     * @param {Boolean} message  验证失败时的消息
     */
    invalid (message) {
      this.valid = false
      this.touched = true
      this.message = message
      this.pushResult()
    },
    /**
     * 使用注入的方法上报验证结果到 form
     */
    pushResult () {
      this.$nextTick(() => {
        this.$emit('validate', this.result)
        this._gkuiFormAcceptModel && this._gkuiFormAcceptModel(this.result)
      })
    }
  }
}
